// extracted by mini-css-extract-plugin
module.exports = {"sphere":"Pod_sphere__3I_DS","left":"Pod_left__wA6ti","right":"Pod_right__o2xsf","img":"Pod_img__2Mf1_"};